/**
 * @description 退货不满意率
 *
 * @props {string} 
 *
 * @slot {插槽} 
 *
 */
<template>
  <div class="content">
    <div class="title">
      <div class="title-item">退货不满意率</div>
      <div class="title-item">目标：低于10% </div>
      <div class="title-item">时间范围：{{ returnDissatisfactionData.duration }}天</div>
      <div class="title-item">{{ returnDissatisfactionData.timeFrameStart | convertToDate }} - {{ returnDissatisfactionData.timeFrameEnd | convertToDate }}</div>
    </div>
    <div class="main">
      <div class="grid1" :style="{width: explain ? '10%' : '20%'}">
        <div class="rate" :class="{abnormal: !returnDissatisfactionData.returnDissatisfaction.completeTarget}">{{ returnDissatisfactionData.returnDissatisfaction.rate }}</div>
        <div class="col">
          <span>负面退货请求：</span>
          <span>{{ returnDissatisfactionData.returnDissatisfaction.count }}</span>
        </div>
        <div class="col">
          <span>退货请求总数：</span>
          <span>{{ returnDissatisfactionData.count }}</span>
        </div>
      </div>
      <div class="grid2" :style="{width: explain ? '50%' : '70%'}">
        <gj-base-table :columns="columns" :datas="datas"></gj-base-table>
      </div>
      <div class="message" v-if="explain">
        <div class="message-cell" v-for="(item, index) in message" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import gjBaseTable from "./gj-base-table.vue";
import { convertToDate } from "@/utils/date.util"
export default {
  props: {
    explain: {
      type: Boolean,
      default: true
    },
    returnDissatisfactionData: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    convertToDate(val) {
      if (!val) { return "" }
      return convertToDate(new Date(val))
    }
  },
  components: {
    "gj-base-table": gjBaseTable,
  },
  data() {
    return {
      columns: [
        {
          name: "缺陷类型",
          id: "flag1",
          width: "30%",
        },
        {
          name: "订单缺陷百分比",
          id: "flag2",
          width: "40%",
          textAlign: "right",
        },
        {
          name: "订单缺陷计数",
          id: "flag3",
          width: "30%",
          textAlign: "right",
        },
      ],
      message: [
        "退货不满意率 (RDR)用来衡量买家对退货体验的满意程度。当退货请求具有负面买家反馈（负面反馈率）、48小时内未得到回复（延迟回复率）或被错误拒绝（无效拒绝率）时，即表示产生了负面的退货体验。退货不满意率是所有负面退货请求数占总退货请求数的百分比。",
        "亚马逊的政策规定，卖家需维持低于10%的退货不满意率(RDR)。目前，亚马逊不会对未满足此绩效目标的卖家施加处罚，但问题未得到解决的买家更有可能提交负面反馈和提出亚马逊商城交易保障索赔。"
      ],
    };
  },
  computed: {
    datas() {
      let datas = [
        { flag1: "负面回复", flag2: "", flag3: "", completeTarget: true},
        { flag1: "延迟回复", flag2: "", flag3: "", completeTarget: true},
        { flag1: "无效拒绝", flag2: "", flag3: "", completeTarget: true},
      ]
      if (this.returnDissatisfactionData.returnDissatisfaction) {
        let { rate, count, completeTarget } = this.returnDissatisfactionData.negativeReturnFeedback
        datas[0].flag2 = rate
        datas[0].flag3 = count
        datas[0].completeTarget = completeTarget
      }
      if (this.returnDissatisfactionData.lateResponse) {
        let { rate, count, completeTarget } = this.returnDissatisfactionData.lateResponse
        datas[1].flag2 = rate
        datas[1].flag3 = count
        datas[1].completeTarget = completeTarget
      }
      if (this.returnDissatisfactionData.invalidRejection) {
        let { rate, count, completeTarget } = this.returnDissatisfactionData.invalidRejection
        datas[2].flag2 = rate
        datas[2].flag3 = count
        datas[2].completeTarget = completeTarget
      }
      return datas
    }
  },
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.content {
  padding-bottom: 10px;
  .title {
    line-height: 1;
    padding: 8px 0 18px 10px;
    font-size: 12px;
    display: flex;
    color: #666;
    .title-item {
      padding-left: 12px;
      &:first-child {
        padding-left: 0;
        font-weight: bold;
      }
      &:last-child {
        padding-left: 20px;
      }
    }
  }
  .main {
    display: flex;
    justify-content: space-between;
    .grid1 {
      width: 10%;
      padding-left: 50px;
      .rate {
        padding: 18px 0 0;
        font-size: 24px;
        font-weight: 600;
        color: #333;
      }
      .col {
        padding-top: 22px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #666;
      }
    }
    .grid2 {
      width: 50%;
      padding: 0 33px 0 14px;
    }
    .message {
      width: 30%;
      font-size: 12px;
      color: #666;
      line-height: 20px;
      padding: 10px 26px 10px 14px;
      border-left: 1px solid #ccc;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
    }
  }
}
</style>